/**
 * OS notification constants (consolidated)
 */

/**
 * OS Notification Command Keys
 */

export const NOTIFICATION_COMMAND_KEYS = {
    OSASCRIPT: "osascript",
    NOTIFY_SEND: "notifySend",
    POWERSHELL: "powershell",
    AFPLAY: "afplay",
    PAPLAY: "paplay",
    APLAY: "aplay",
} as const;

/**
 * OS Notification Commands
 */

export const NOTIFICATION_COMMANDS = {
    OSASCRIPT: "osascript",
    NOTIFY_SEND: "notify-send",
    POWERSHELL: "powershell",
    AFPLAY: "afplay",
    PAPLAY: "paplay",
    APLAY: "aplay",
} as const;

